import React, { CSSProperties } from "react";
import { Tooltip } from "@mui-styled-components/Tooltip";
import styles from "./SubHeaderFilled.module.less";

export type SubHeaderFilledPropsT = {
  title: string | React.ReactNode;
  sectionID?: string;
  subTitle?: string | React.ReactNode;
  sideText?: string | React.ReactNode;
  tooltipText?: string;
  color?: string;
  containerStyles?: CSSProperties;
  titleStyles?: CSSProperties;
  subTitleStyles?: CSSProperties;
  sideTextStyles?: CSSProperties;
  isGradientBackground?: boolean;
  titleContainerStyles?: CSSProperties;
};

const SubHeaderFilled = ({
  title,
  subTitle,
  sideText,
  tooltipText,
  sectionID,
  isGradientBackground = false,
  color = isGradientBackground ? "var(--white)" : "var(--darkest-blue)",
  containerStyles = {},
  titleStyles = {},
  subTitleStyles = {},
  sideTextStyles = {},
  titleContainerStyles = {},
}: SubHeaderFilledPropsT) => {
  return (
    <div
      id={sectionID}
      className={isGradientBackground ? styles.subHeaderFilledGradientContainer : styles.subHeaderFilledContainer}
      style={{ ...containerStyles }}
    >
      <div className={styles.subHeaderContainer} style={{ ...titleContainerStyles }}>
        <div style={{ ...titleStyles, color }} className={styles.title}>
          {title}

          {tooltipText && (
            <Tooltip placement="top" title={<div className={styles.tooltipContent}>{tooltipText}</div>}>
              <div className={styles.tooltipIcon}>!</div>
            </Tooltip>
          )}
        </div>
        <div style={{ ...sideTextStyles }} className={styles.sideText}>
          {sideText}
        </div>
      </div>
      {subTitle && (
        <div style={{ ...subTitleStyles, color }} className={styles.subTitle}>
          {subTitle}
        </div>
      )}
    </div>
  );
};

export default SubHeaderFilled;
